import React from "react";
import { Switch, Route, Redirect } from "react-router-dom";
import Branches from "../../features/branches/index";
import BranchDetails from "../../features/branchDetails/index";
import Clients from "../../features/clients/index";
import Users from "../../features/users/index";
import ClientDetails from "../../features/clientDetails/index";
import UserDetails from "../../features/userDetails/index";
import Employees from "../../features/employees/index";
import EmployeeDetails from "../../features/employeeDetails/index";
import PatientsList from "../../features/patients/index";
import Assets from "../../features/assets/index";
import Patient from "../../features/patient/index";
import Profile from "../../features/user/Profile";
import Settings from "../../features/settings/index";
import DashboardPage from "../../features/dashboard/index";
import Gaps from "../../features/gaps/index";
import Salary from "../../features/salary/index";
import Prospectuses from "../../features/prospectuses/index";
import Reports from "../../features/reports/index";
import Report from "../../features/report/index";
import Leads from "../../features/crm/leads/index";
import Lead from "../../features/crm/lead/index";
import Opportunities from "../../features/crm/opportunities";
import Opportunity from "../../features/crm/opportunity";
import Contacts from "../../features/crm/contacts";
import Contact from "../../features/crm/contact";
import Campaigns from "../../features/crm/campaigns";
import Campaign from "../../features/crm/campaign";
import Events from "../../features/crm/events";
import Ok2GoRevaha from "../../features/ok2Go/Ok2GoRevaha";
import Ok2GoBtl from "../../features/ok2Go/Ok2GoBtl";
import DayCenter from "../../features/dayCenter";
import OrdersImport from "../../features/ordersImport";

const Router = ({ defaultResource }) => {
  return (
    <Switch>
      <Route exact path={"/admin/"}>
        <Redirect to={`/admin/${defaultResource}`} />
      </Route>
      <Route exact path={"/admin/dashboard"}>
        <DashboardPage />
      </Route>
      <Route exact path={"/admin/users"}>
        <Users />
      </Route>
      <Route exact path={"/admin/users/:id"}>
        <UserDetails mode="edit" />
      </Route>
      <Route exact path={"/admin/branches"}>
        <Branches />
      </Route>
      <Route exact path={"/admin/branches/add"}>
        <BranchDetails mode="new" />
      </Route>
      <Route exact path={"/admin/branches/:id"}>
        <BranchDetails mode="edit" />
      </Route>
      <Route exact path={"/admin/clients"}>
        <Clients />
      </Route>
      <Route exact path={"/admin/clients/add"}>
        <ClientDetails mode="new" />
      </Route>
      <Route exact path={"/admin/clients/:id"}>
        <ClientDetails mode="edit" />
      </Route>
      <Route exact path={"/admin/employees"}>
        <Employees />
      </Route>
      <Route exact path={"/admin/employees/:id"}>
        <EmployeeDetails mode="edit" />
      </Route>
      <Route exact path={"/admin/patients"}>
        <PatientsList />
      </Route>
      <Route exact path={"/admin/patients/:id"}>
        <Patient mode="edit" />
      </Route>
      <Route exact path={"/admin/gaps"}>
        <Gaps />
      </Route>
      <Route exact path={"/admin/diaries_approval"}>
        <Gaps diariesApproval={true} />
      </Route>
      <Route exact path={"/admin/branch_salary"}>
        <Salary />
      </Route>
      <Route exact path={"/admin/accounting"}>
        <Prospectuses />
      </Route>
      <Route exact path={"/admin/profile"}>
        <Profile />
      </Route>
      <Route exact path={"/admin/assets"}>
        <Assets fromMain={true} />
      </Route>
      <Route exact path={"/admin/reports"}>
        <Reports />
      </Route>
      <Route exact path={"/admin/ok2go_btl"}>
        <Ok2GoBtl />
      </Route>
      <Route exact path={"/admin/ok2go_revaha"}>
        <Ok2GoRevaha />
      </Route>
      <Route exact path={"/admin/reports/:id"}>
        <Report />
      </Route>
      <Route exact path={"/admin/leads"}>
        <Leads />
      </Route>
      <Route exact path={"/admin/leads/:id"}>
        <Lead />
      </Route>
      <Route exact path={"/admin/crm_patients"}>
        <Opportunities />
      </Route>
      <Route exact path={"/admin/crm_patients/:id"}>
        <Opportunity />
      </Route>
      <Route exact path={"/admin/contacts"}>
        <Contacts />
      </Route>
      <Route exact path={"/admin/contacts/:id"}>
        <Contact />
      </Route>
      <Route exact path={"/admin/campaigns"}>
        <Campaigns />
      </Route>
      <Route exact path={"/admin/campaigns/:id"}>
        <Campaign />
      </Route>
      <Route exact path={"/admin/day_center"}>
        <DayCenter />
      </Route>
      <Route exact path={"/admin/order_import"}>
        <OrdersImport />
      </Route>

      <Route exact path={"/admin/events_schedule"}>
        <Events />
      </Route>
      <Route exact path={"/admin/organization.settings"}>
        <Settings />
      </Route>
    </Switch>
  );
};

export default Router;
